<template>
   <div class="card-container" onclick="">
      <div class="recommended-equipment-container">
         <img :src="require(`../assets/pages/${icon}`)" alt="card">
         <h3>{{title}}</h3>
         <a v-if="link!=null" :href="link" target="_blank">{{$t('pages.features.playerCard.equipCards.moreDetails')}}&nbsp;&rarr;</a>
         <div class="card-content">
            <h4>{{desc}}</h4>
            <p>
               <slot></slot>
            </p>
         </div>
      </div>
   </div>
</template>

<script>
    export default {
        name: "AnimatedCard",
        props: ['title', 'desc', 'icon', 'link'],
    }
</script>

<style scoped lang="scss">
   @import "../theme/theme";

   .card-container {
      overflow: hidden;
      height: 9rem;
      user-select: none;
      border: $back60 1px solid;

      .advantage-checker {
         display: none;
      }
   }


   .recommended-equipment-container {
      display: grid;
      grid-template-rows: 6em;
      grid-template-columns: auto;
      padding: 1em;

      img {
         grid-row: 1;
         grid-column: 1;
         width: 100%;
         transition-duration: .25s;
         z-index: -1;
      }

      h3 {
         font-weight: 300;
         font-size: 1.5rem;
         grid-row: 1;
         grid-column: 1;
      }

      a{
         font-weight: 300;
         font-size: 0.7rem;
         grid-row: 1;
         grid-column: 1;
         justify-self: end;
         align-self: start;
         cursor: pointer;
         z-index: 1;
         color: $text80;
         text-decoration: none;
         visibility: collapse;
      }

   }

   .card-content {
      display: grid;
      position: relative;
      grid-template-rows: auto auto;
      top: 6rem;
      grid-row: 1;
      grid-column: 1;
      transition-duration: .25s;

      h4 {
         font-weight: 300;
         font-size: 1.1rem;
         background: url("../../src/assets/icons/expand.svg") no-repeat;
         background-size: 1.1rem;
         background-position-y: top;
         padding-left: 1.2em;
      }

      p {
         font-weight: 400;
         font-size: 1rem;
      }
   }

   .card-container:hover > .recommended-equipment-container .card-content {
      top: 2rem;
   }

   .card-container:hover > .recommended-equipment-container img {
      opacity: 0.0;
   }
   .card-container:hover > .recommended-equipment-container a {
      visibility: visible;
   }
</style>